const careers = [
    {
      title: "Chargé de mission RH",
      id:"1",
      details:  [
        "Tunis/Sfax",
        "CDI | 100% Télétravail",
        "Missions ponctuelles possibles au Canada/Europe"
      ],
      detailData: {
        id:"1",
        title: "Chargé de mission RH",
        subtitle: "MyOutsourcing est une entreprise tunisienne innovante qui met à disposition des cabinets de conseil, d’audit et de comptabilité basés au Canada et en Europe des talents qualifiés, salariés de MyOutsourcing, en 100 % télétravail depuis la Tunisie. Nous combinons flexibilité, stabilité,rémunération attractive et exposition internationale.",
        sections: [
          { title: "Vos missions :", points: [
          "Gérer le cycle RH : recrutement, intégration, administration du personnel et reporting",
           "Coordonner les évaluations, les plans de carrière et la gestion de la performance",
            "Contribuer à des projets RH transverses : digitalisation, fidélisation, QVT, culture d’entreprise",
            ] },
          { title: "Pourquoi nous rejoindre :", points: [
          "100 % télétravail permanent",
          "Rémunération fixe + variable attractives",
          "Possibilité de missions courtes au Canada ou en Europe",
          "Formations continues, certifications, évolution professionnelle",
          "Encadrement de proximité et environnement international"] },
          { title: "Profil recherché :", points: [
            "Bac+3/5 en RH ou management",
            "Débutant(e) accepté(e) ou avec une première expérience",
            "Maîtrise impérative du français et de l’anglais",
            "Aisance bureautique (Excel, Word, PowerPoint), autonomie, rigueur, bon relationne",
          ] },
        ]
      }
    },
    {
      title: "Consultant Audit des Systèmes d’Information",
      id:"2",
      details: [
        "Tunis/Sfax",
        "CDI | 100% Télétravail",
        "Missions ponctuelles possibles au Canada/Europe"
      ],
      detailData: {
        id:"2",
        title: "Consultant Audit des Systèmes d’Information",
        subtitle: "MyOutsourcing est une entreprise tunisienne innovante qui met à disposition des cabinets de conseil, d’audit et de comptabilité basés au Canada et en Europe des talents qualifiés, salariés de MyOutsourcing, en 100 % télétravail depuis la Tunisie. Nous combinons flexibilité, stabilité,rémunération attractive et exposition internationale.\n\n Dans le cadre du développement de notre pôle IT Audit, nous recrutons un consultant spécialisé en audit des systèmes d’information.",
        sections: [
          { title: "Vos missions :", points: [
            "Réaliser des audits de systèmes d'information et de conformité",
            "Accompagner les clients dans la mise en place de référentiels de contrôle interne",
            "Intervenir sur des projets de transformation des SI, incluant la revue des migrations de données",
            "Participer activement à toutes les phases des missions : cadrage, fieldwork, restitution" ,
            "Contribuer à des actions de développement internes et externes (formations, publications,veille)",
          ] },
          { title: "Pourquoi nous rejoindre :", points: [
            "Télétravail permanent depuis la Tunisie",
            "Rémunération fixe et variable attractive",
            "Possibilité de missions ponctuelles au Canada ou en Europe" ,
            "Formations continues, certifications (CISA, COBIT, ITIL…) et perspectives d’évolution",
            "Management de proximité et environnement multiculturel"] },
          { title: "Profil recherché :", points: [
            "Diplôme d’ingénieur ou master en management des systèmes d’information ou équivalent",
          "Minimum 2 ans d’expérience en audit des SI ou en conseil IT",
        "Maîtrise du français, à l’oral comme à l’écrit",
        "Rigueur, sens de l’organisation et bon esprit d’équipe",
        "Force de proposition, autonomie et qualités rédactionnelles solides"
        ]},
        ]
      }
    },
    {
      title: "Consultant Comptable Junior",
      id:"3",
      details: [
        "Tunis/Sfax",
        "CDI | 100% Télétravail",
        "Missions ponctuelles possibles au Canada/Europe",
      ],
      detailData: {
        id:"3",
        title: "Consultant Comptable Junior",
        subtitle: "MyOutsourcing est une entreprise tunisienne innovante qui met à disposition des cabinets de conseil, d’audit et de comptabilité basés au Canada et en Europe des talents qualifiés, salariés de MyOutsourcing, en 100 % télétravail depuis la Tunisie. Nous combinons flexibilité, stabilité,rémunération attractive et exposition internationale.",
        sections: [
          { title: "Vos missions :", points: [
            "Soutenir les clôtures financières mensuelles",
            "Effectuer des contrôles pour garantir l'intégrité des données financières",
            "Préparer des rapports financiers précis pour la direction",
            "Participer à l'analyse des chiffres mensuels et trimestriels",
            "Fournir des informations fiables aux parties prenantes",
          ] },
          { title: "Pourquoi nous rejoindre :", points: [
            "100 % télétravail permanent",
            "Rémunération fixe + variable attractive",
            "Possibilité de missions courtes au Canada ou en Europe",
            "Formations continues, certifications, évolution professionnelle",
            "Encadrement de proximité et environnement international",
          ] },
          { title: "Profil recherché :", points: [
            "Diplôme en comptabilité, finance ou équivalent",
            "Débutant(e) accepté(e)",
            "Excellente compréhension des processus comptables",
            "Maîtrise impérative du français et de l’anglais",
            "Très bonne maîtrise d’Excel et PowerPoint",
            "Sens de l’analyse, proactivité, rigueur et esprit d’équipe"

        ] },
        ]
      }
    },
    {
      title: "Consultant Contrôle de Gestion – Clôtures Mensuelles",
      id:"4",
      details: [
        "Tunis/Sfax",
        "CDI | 100% Télétravail",
        "Missions ponctuelles possibles au Canada/Europe",
      ],
      detailData: {
        id:"4",
        title: "Consultant Contrôle de Gestion – Clôtures Mensuelles",
        subtitle: "MyOutsourcing est une entreprise tunisienne innovante qui met à disposition des cabinets de conseil, d’audit et de comptabilité basés au Canada et en Europe des talents qualifiés, salariés de MyOutsourcing, en 100 % télétravail depuis la Tunisie. Nous combinons flexibilité, stabilité,rémunération attractive et exposition internationale.\n\n Dans le cadre de notre développement, nous recrutons un consultant expérimenté en contrôle degestion et clôtures mensuelles.",
        sections: [
          { title: "Vos missions :", points: [
            "Participer aux clôtures financières mensuelles",
            "Réaliser les contrôles garantissant l’intégrité des données financières",
            "Préparer des reportings financiers fiables à destination du management",
            "Superviser les activités de contrôle financier (revue et analyse mensuelle et trimestrielle)",
            "Fournir des informations financières complètes et précises aux parties prenantes",
          ] },
          { title: "Tâches quotidiennes :", points: [
            "Exécuter les processus dans l’ERP",
            "Préparer et analyser les rapports financiers",
            "Suivre les contrôles internes",
            "Superviser et élaborer les comptes de résultat",
            "Participer à l’élaboration budgétaire",
          ] },
          { title: "Pourquoi nous rejoindre :", points: [
            "100 % télétravail permanent",
            "Rémunération fixe + variable attractive",
            "Possibilité de missions courtes au Canada ou en Europe",
            "Formations continues, certifications, évolution professionnelle",
            "Encadrement de proximité et environnement international",
        ] },
        { title: "Profil recherché :", points: [
          "Licence en comptabilité, finance, administration des affaires, mathématiques, économie ou domaine connexe",
          "Minimum 3 ans d’expérience dans un rôle en comptabilité, audit ou finance",
          "Excellentes compétences en communication, rigueur et gestion du temps",
          "Maîtrise avancée d’Excel et PowerPoint",
          "Capacité à traiter un grand volume de données",
          "Connaissance des outils de reporting tels que Planning Analytics",
          "Maîtrise du français et de l’anglais"
      ] },
        ]
      }
    },
    {
      title: "Consultant Junior – Fund Reporting (OPERATE)",
      id:"5",
      details: [
        "Tunis/Sfax",
        "CDI | 100% Télétravail",
        "Missions ponctuelles possibles au Canada/Europe",
      ],
      detailData: {
        id:"5",
        title: "Consultant Junior – Fund Reporting (OPERATE)",
        subtitle: "MyOutsourcing est une entreprise tunisienne innovante qui met à disposition des cabinets de conseil, d’audit et de comptabilité basés au Canada et en Europe des talents qualifiés, salariés de MyOutsourcing, en 100 % télétravail depuis la Tunisie. Nous combinons flexibilité, stabilité,rémunération attractive et exposition internationale.\n\n Dans le cadre de notre croissance, nous recrutons 4 consultants juniors pour notre activité de FundReporting (OPERATE).",
        sections: [
          { title: "Vos missions :",  points: [
            "Préparer et nettoyer les fichiers de travail (suppression d’anciennes données, préparation de tableaux vierges)",
            "Mettre à jour les rapports suite aux changements dans les prospectus ou documents légaux",
            "Adapter les libellés selon le type de rapport et les informations reçues",
            "Convertir, combiner et mettre à jour les données financières (Word/Excel)",
            "Vérifier les formules Excel et assurer la cohérence des fichiers",
            "Suivre et actualiser le planning de production",
            "Participer à la revue qualité : mise en page, intégration de commentaires",
            "Préparer et mettre à jour les rapports KPI de suivi de production"
          ] },
          { title: "Tâches quotidiennes :", points: [
            "Enregistrement des factures via OCR",
            "Gestion des anomalies et suivi",
            "Saisie de rapports quotidiens",
            "Collecte et vérification des informations liées aux paiements",
            "Consultation des fichiers fournisseurs et affectation des numéros de bons de commande (PO)",
            "Vérification de la conformité des factures avec les PO et la réception des biens/services",
            "Production quotidienne de reportings"
        ] },
          { title: "Pourquoi nous rejoindre :", points: [
            "100 % télétravail permanent",
            "Rémunération fixe + variable attractive",
            "Possibilité de missions courtes au Canada ou en Europe",
            "Formations continues, certifications, évolution professionnelle",
            "Encadrement de proximité et environnement international",
        ] },
        { title: "Profil recherché :", points: [
          "Titulaire d’un Master en audit, finance, comptabilité, économie ou discipline équivalente ; ou Licence avec expérience en audit, comptabilité ou fonds d’investissement",
          "Forte capacité d’analyse et orientation des résultats",
          "Créativité, autonomie et capacité à proposer des idées et solutions nouvelles",
          "Excellentes compétences en communication et en relation client",
          "Solide maîtrise de Word et Excel ; compétences avancées en VBA et/ou SQL",
          "Maîtrise parfaite du français et de l’anglais, à l’oral comme à l’écrit",
      ] },
        ]
      }
    },
    {
      title: "Consultant Comptabilité Fournisseurs (Payables)",
      id:"6",
      details: [
        "Tunis/Sfax",
        "CDI | 100% Télétravail",
        "Missions ponctuelles possibles au Canada/Europe",
      ],
      detailData: {
        id:"6",
        title: "Consultant Comptabilité Fournisseurs (Payables)",
        subtitle: "MyOutsourcing est une entreprise tunisienne innovante qui met à disposition des cabinets de conseil, d’audit et de comptabilité basés au Canada et en Europe des talents qualifiés, salariés de MyOutsourcing, en 100 % télétravail depuis la Tunisie. Nous combinons flexibilité, stabilité,rémunération attractive et exposition internationale.\n\n Nous recrutons un consultant en comptabilité fournisseurs (Payables), rigoureux et organisé, pour renforcer nos équipes à distance.",
        sections: [
          { title: "Vos missions :", points: [
            "Comptabiliser les transactions, traiter les factures et vérifier les données financières",
            "Tenir des registres précis des dettes fournisseurs",
            "Garantir l’exactitude des documents financiers à des fins de paiement, d’audit et de fiscalité",
            "Prévenir les sur paiements involontaires",
            "Assurer un suivi efficace pour garantir des paiements fournisseurs dans les délais",
          ] },
          { title: "Tâches quotidiennes :", points: [
            "Enregistrement des factures via OCR",
            "Gestion des anomalies et suivi",
            "Saisie de rapports quotidiens",
            "Collecte et vérification des informations liées aux paiements",
            "Consultation des fichiers fournisseurs et affectation des numéros de bons de commande(PO)",
            "Vérification de la conformité des factures avec les PO et la réception des biens/services",
            "Production quotidienne de reportings"
        ] },
          { title: "Pourquoi nous rejoindre :", points: [
            "100 % télétravail permanent",
            "Rémunération fixe + variable attractive",
            "Possibilité de missions courtes au Canada ou en Europe",
            "Formations continues, certifications, évolution professionnelle",
            "Management de proximité et environnement multiculturel",
        ] },
        { title: "Profil recherché :", points: [
          "Diplôme en comptabilité, finance, économie ou gestion",
          "Connaissance des bases de la comptabilité et des écritures comptables",
          "Rigueur, sens du détail, capacité d’analyse et d’organisation",
          "Compétences en calcul, communication écrite et orale",
          "Aptitude à résoudre les problèmes de manière proactive",
          "Maîtrise du français et de l’anglais",
      ] },
      ]
      }
    },
    
  ];
  
  export default careers;
  